import React, { useState, useEffect } from "react";
import { StepProps } from "../../../config/types";

interface Step8Props extends StepProps {
  setStepValid: React.Dispatch<React.SetStateAction<boolean>>;
}

const Step8: React.FC<Step8Props> = ({
  handleChange,
  formValues,
  setStepValid,
}) => {
  const [selectedOption, setSelectedOption] = useState<string | null>(
    formValues.q8_do_you_currently_take_any_medications?.[0] || null
  );
  const [medicationDetails, setMedicationDetails] = useState<string>(
    formValues.q8_medication_details?.[0] || ""
  );

  useEffect(() => {
    const isStepValid =
      selectedOption !== null &&
      (selectedOption === "Yes" ? medicationDetails.trim() !== "" : true);
    setStepValid(isStepValid);

    if (selectedOption) {
      handleChange({
        target: {
          name: "q8_do_you_currently_take_any_medications",
          value: [selectedOption],
        },
      } as unknown as React.ChangeEvent<HTMLInputElement>);
    }

    if (selectedOption === "Yes" && medicationDetails.trim() !== "") {
      handleChange({
        target: {
          name: "q8_medication_details",
          value: [medicationDetails],
        },
      } as unknown as React.ChangeEvent<HTMLInputElement>);
    }
  }, [selectedOption, medicationDetails, setStepValid]);

  const handleOptionChange = (value: string) => {
    setSelectedOption(value);
    if (value !== "Yes") {
      setMedicationDetails("");
      handleChange({
        target: {
          name: "q8_medication_details",
          value: [""],
        },
      } as unknown as React.ChangeEvent<HTMLInputElement>);
    }
  };

  const handleMedicationDetailsChange = (
    e: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    setMedicationDetails(e.target.value);
  };

  return (
    <div className="min-h-[50vh] lg:px-[50px] px-[0px] ">
      <p className="text-[#000000] text-[18px] font-[400] text-left mb-5">
        8. Do you currently take any medications?
      </p>
      <div className="flex flex-row gap-[20px] items-center my-3 mb-7">
        <button
          type="button"
          onClick={() => handleOptionChange("Yes")}
          className={`min-h-[45px] rounded-[5px] min-w-[102px] border border-[#3B82F6] ${
            selectedOption === "Yes"
              ? "bg-[#3B82F6] text-white"
              : "text-[#000000] bg-[#ffffff]"
          }`}
        >
          Yes
        </button>
        <button
          type="button"
          onClick={() => handleOptionChange("No")}
          className={`min-h-[45px] rounded-[5px] min-w-[102px] border border-[#3B82F6] ${
            selectedOption === "No"
              ? "bg-[#3B82F6] text-white"
              : "text-[#000000] bg-[#ffffff]"
          }`}
        >
          No
        </button>
      </div>

      {selectedOption === "Yes" && (
        <div className="mt-4">
          <p className="text-[#000000] text-[18px] font-[400] text-left">
            Please provide us with the name, dose, and frequency of all your
            medications
          </p>
          <textarea
            name="q8_medication_details"
            value={medicationDetails}
            onChange={handleMedicationDetailsChange}
            className="w-full p-2 border border-gray-300 rounded mt-2"
            rows={5}
            placeholder="Enter your medication details"
          />
        </div>
      )}
    </div>
  );
};

export default Step8;
